module.exports = __webpack_public_path__ + "static/img/liucheng2.0cc0722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/liucheng2.png
// module id = BCAq
// module chunks = 18